import { j as c } from "../../jsx-runtime-DmTjM30f.js";
import { u as i } from "../../index-EY1gwl5O.js";
import { BreakpointContext as h } from "./breakpointContext.js";
import { useMemo as w } from "react";
const t = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1440px"
}, M = ({ children: p }) => {
  const s = i(`(max-width: ${t.sm})`), o = i(`(min-width: ${t.sm})`), m = i(`(min-width: ${t.md})`), n = i(`(min-width: ${t.lg})`), r = i(`(min-width: ${t.xl})`), e = i(`(min-width: ${t["2xl"]})`), d = i(`(max-width: ${t.md})`), x = i(
    `(min-width: ${t.md}) and (max-width: ${t.lg})`
  ), l = i(`(min-width: ${t.lg})`), a = w(() => ({
    isXs: s,
    isSm: o,
    isMd: m,
    isLg: n,
    isXl: r,
    is2xl: e,
    isMobile: d,
    isTablet: x,
    isDesktop: l
  }), [l, n, m, d, o, x, e, r, s]);
  return /* @__PURE__ */ c.jsx(h.Provider, { value: a, children: p });
};
export {
  M as BreakpointProvider,
  M as default
};
